import React from "react";
import {DialogContent, DialogTitle} from "@mui/material";
import Dialog from "../../base/dialog";
import BirthdayGif from '../../../../assets/gifs/birthday_cake.gif';

const BirthdayDialog = ({open, close, name}) => {

    return (
        <>
            <Dialog
                open={open}
                setOpen={() => close()}
                maxWidth={'sm'}
                className={'bound-dialog birthday-dialog'}
                scroll={'paper'}
                aria-labelledby="scroll-dialog-title"
            >
                <DialogTitle id={'scroll-dialog-title'}>
                    <p className={`text-lg text-color-1 my-3 font-weight-bold text-center`}>
                        Happy birthday {name ?? ""}
                    </p>
                </DialogTitle>
                <DialogContent className={'birthday-dialog-content'}>
                    <img src={BirthdayGif} alt="happy birthday"/>
                    <p>
                        Happy Birthday {name ?? ''}, We wish you the biggest slice of happy today. <br/>
                        You age is merely the number of years the world has been enjoying you!!
                    </p>
                    <p>
                        With love, Bizkey Tech Family.
                    </p>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default BirthdayDialog;
